module.exports = __webpack_public_path__ + "img/654966a8aec19bcf998acad6abe96173.png";